import React from "react";
import { PageHeader, TeamMember } from "../../components";
import SnookerGallery from "./directory/snooker";
import style from "./style.module.css";
export default function Snooker() {
  return (
    <div className="page-content">
      <PageHeader title="Snooker " page="snooker" />
      {/* <!-- Content -> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row --> */}

        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          {/* <!-- Our Awesome Services --> */}
          <div className="section-full bg-gray content-inner ">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center section-head mamber-dec">
                  <h3 className="h2">WELCOME TO SNOOKER</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <div className="clear"></div>
                  <h5 class="font-weight-3 m-b30">
                    The Snooker & Billiards Section is the oldest and one of the
                    most distinguished sections of the Club. It fosters a warm
                    and inclusive atmosphere, welcoming professional,
                    intermediate, and beginner players alike.
                  </h5>
                  <h5>
                    Equipped with three full-size snooker tables and a
                    tastefully designed entertainment lounge, the section is the
                    cynosure of all eyes — truly “the place to be.”
                  </h5>
                  <h5>
                    Socially vibrant, the section regularly hosts sponsored
                    events and friendly gatherings, promoting camaraderie among
                    members. Competitive spirit thrives here, as tournaments and
                    championships are organized frequently, providing a platform
                    for members to test their skills and improve their game.
                  </h5>
                  <h5>
                    Whether you're a seasoned player or just starting out, the
                    Snooker & Billiards Section offers an engaging environment
                    to enjoy the sport, connect with fellow enthusiasts, and be
                    part of a legacy of excellence.
                  </h5>
                  {/* <a href="/#" className="site-button">Learn More</a> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- About Company END --> */}
          {/* <!-- Gallery Section --> */}
          <SnookerGallery />
          {/* <!-- Team member --> */}
          <TeamMember
            name="MR. TOMI OLURINOLA"
            title="Chairman Snooker Sections."
            img="./assets/images/members/LCC3.jpeg"
          />
          {/* <!-- Team member --> */}
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
